var _defs, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatarNoShadow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.0242,
    height: 26.739941,
    viewBox: "0 0 10.0242 26.739941",
    fill: "none",
    id: "svg22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs26"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2650_18555",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.0966,
    height: 40.109901,
    fill: "#d9d9d9",
    id: "rect15",
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2650_18555)",
    id: "g20",
    transform: "translate(-15.0361,-6.68506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 20.0482,12.5344 c -0.8075,0 -1.4967,-0.2855 -2.0675,-0.8565 -0.5708,-0.571 -0.8562,-1.2604 -0.8562,-2.06816 0,-0.80777 0.2854,-1.49716 0.8562,-2.06817 0.5708,-0.57101 1.26,-0.85651 2.0675,-0.85651 0.8075,0 1.4967,0.2855 2.0675,0.85651 0.5708,0.57101 0.8562,1.2604 0.8562,2.06817 0,0.80776 -0.2854,1.49716 -0.8562,2.06816 -0.5708,0.571 -1.26,0.8565 -2.0675,0.8565 z M 16.7068,33.425 v -8.3562 h -1.6707 v -7.5206 c 0,-0.9192 0.3272,-1.7061 0.9816,-2.3607 0.6543,-0.6546 1.4409,-0.9818 2.3598,-0.9818 h 3.3414 c 0.9189,0 1.7055,0.3272 2.3599,0.9818 0.6543,0.6546 0.9815,1.4415 0.9815,2.3607 v 7.5206 h -1.6707 v 8.3562 z",
    fill: "#ff6464",
    id: "path18"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarNoShadow);
export default __webpack_public_path__ + "static/media/avatar_no_shadow.f9f09305e1297b6af30f9cfd3fb18f73.svg";
export { ForwardRef as ReactComponent };